import React, { useState } from 'react';
import './App.css';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { Line } from 'react-chartjs-2';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  BarController,
  LineController
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  BarController,
  LineController
);

function App() {
  const [userName, setUserName] = useState('');
  const [payPoint, setPayPoint] = useState();
  const [remainPayPoint, setRemainPayPoint] = useState('');
  const [remainPayPointList, setRemainPayPointList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [graphBoard, setGraphBoard] = useState(false);
  const [totalRemainingPoints, setTotalRemainingPoints] = useState(0);
  const [thisWeekPoint, setThisWeekPoint] = useState([]);
  const [LastWeekPoint, setLastWeekPoint] = useState([]);
  const [todayTotalPoints, setTodayTotalPoints] = useState();
  const [todayTotalUsagePoints, setTodayTotalUsagePoints] = useState();


  const menu = [    
    { name: '햄에그 샌드위치', price: 5500 },    
    { name: '햄치즈 샌드위치', price: 5500 },
    { name: '크래미 샌드위치', price: 6000 },
    { name: '떡갈비 샌드위치', price: 6500 },
    { name: '핫치킨 샌드위치', price: 6500 },
    { name: '훈제오리 샐러드', price: 8000 },
    { name: '닭가슴살 샐러드', price: 7500 },
    { name: '단호박 샐러드', price: 6000 },
    { name: '에그 샐러드', price: 5500 },
    { name: '에그,훈제오리 세트추가', price: 2000 },
    { name: '세트 추가', price: 1500 }
  ];
  const drink = [    
    { name: '에스프레소', price: 2500 },
    { name: '아메리카노', price: 2500 },
    { name: '카페라떼', price: 3000 },
    { name: '바닐라 라떼', price: 3500 },
    { name: '모카 라떼', price: 3500 },
    { name: '사이즈업', price: 500 },
    { name: '디카페인,라떼류 아이스 변경', price: 500 },
    { name: '블루베리,딸기 라떼', price: 4000 },
    { name: '블루베리,딸기,레몬 에이드', price: 3500 },
    { name: '레몬차', price: 3000 },
    { name: '루이,페퍼,케모 티', price: 2500 },
  ];
  const backendURL = "https://sandwichapi.brokers-x.com";

  let data =  {
    labels: ['월', '화', '수', '목', '금'],
    datasets: [
      {
        type: 'bar',
        label: '적립 금액',
        borderWidth: 0,
        backgroundColor: 'rgba(255, 99, 132, 0.7)',
        data:thisWeekPoint.length ? thisWeekPoint.map(item => item.payPoints) : []
      },
      {
        type: 'bar',
        label: '차감 금액',
        borderWidth: 0,
        backgroundColor: 'rgba(54,162,235,0.7)',
        data:thisWeekPoint.length ? thisWeekPoint.map(item => item.usagePoints) : []
      },
      {
        type: 'line',
        label: '지난주 적립 금액',
        backgroundColor: 'red',
        borderWidth: 2,
        data:LastWeekPoint.length ? LastWeekPoint.map(item => item.payPoints) : []
      },
      {
        type: 'line',
        label: '지난주 차감 금액',
        backgroundColor: 'blue',
        borderWidth: 2,
        data:LastWeekPoint.length ? LastWeekPoint.map(item => item.usagePoints) : []
      },
    ],
  };

  const handleItemClick = (item) => {
    let updatedItems;
    if (selectedItems.includes(item)) {
      updatedItems = selectedItems.filter((selectedItem) => selectedItem !== item);
    } else {
      updatedItems = [...selectedItems, item];
    }
    
    setSelectedItems(updatedItems);
    
    const total = updatedItems.reduce((acc, item) => acc + (item.price * (item.count || 1)), 0);
    setPayPoint(total);
  };

  const handlePriceInputChange = (event) => {
    setPayPoint(event.target.value);
  };

  const searchAllList = () => {
    fetch(backendURL + `/pays/list/all?page=0&size=60`, {method: 'GET'})
      .then((response) => response.json())
      .then((data) => {
        setRemainPayPointList(data);
        setRemainPayPoint(null);
      })
      .catch((error) => {
        alert("전체 내역 조회 실패");
      });
  }

  const searchValueButton = () => {
    fetch(backendURL + `/pays/total?userName=${userName}`, {method: 'GET'})
      .then((response) => response.json())
      .then((data) => {
        setRemainPayPoint(data.totalPoints);
      })
      .catch((error) => {
        alert("사용자 없음");
      });
    fetch(backendURL + `/pays/list?userName=${userName}`, {method: 'GET'})
      .then((response) => response.json())
      .then((data) => {
        setRemainPayPointList(data);
      })
      .catch((error) => {
        alert("사용자 없음");
      });
  };

  const handleInputChange = (event) => {
    setUserName(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      searchValueButton();
    }
  };

  const oderMenuReset = () => {
    setPayPoint('');
    setSelectedItems([])
  }

  const plusPoint = () => {
    const parsedPayPoint = parseInt(payPoint);
    setPayPoint('');
    setSelectedItems([]);
    fetch(backendURL + '/pays/save', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userName, payPoint:parsedPayPoint, status: '적립' }),
    })
      .then((response) => searchValueButton())
      .then((data) => {
        setRemainPayPoint(data.totalPoints);
      })
      .catch((error) => {
      });
    
  };

  const minusPoint = () => {
    setPayPoint('');
    setSelectedItems([]);
    const parsedPayPoint = parseInt(payPoint);
    fetch(backendURL + '/pays/save', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userName,  payPoint:parsedPayPoint, status: '사용' }),
    })
      .then((response) => searchValueButton())
      .then((data) => {
        setRemainPayPoint(data.totalPoints);
        oderMenuReset();
      })
      .catch((error) => {
      });
  };
  const searchTotalToday = () => {
    fetch(backendURL + `/pays/total/today`, {method: 'GET'})
      .then((response) => response.json())
      .then((data) => {
        setTodayTotalPoints(data.todayTotalPoints);
        setTodayTotalUsagePoints(data.todayTotalUsagePoints);
      })
      .catch((error) => {
        alert("오늘 금액 실패");
      });
  }

  const searchTotalTwoWeeks = () => {
    fetch(backendURL + `/pays/total/two-weeks`, {method: 'GET'})
      .then((response) => response.json())
      .then((data) => {
        setTotalRemainingPoints(data.totalRemainingPoints)
        setThisWeekPoint(data.thisWeekPoints)
        setLastWeekPoint(data.lastWeekPoints)
      })
      .catch((error) => {
        alert("주차별 금액 불러오기 실패");
      });
  }


  return (
    <div style={{ display: 'flex' , height: '100vh'}}>
      <div style={{ minWidth: '380px', padding: '10px', margin: '5px 2.5px 5px 5px', border: '2px solid #E3E1DF',borderRadius:'5px', backgroundColor: '#F5F5F4'}}>
      <div style={{ margin: 'auto', fontWeight: 'bolder', fontSize: '25px', textAlign: 'center'}}>🥪 Sandwich Broker 😊</div>
        <div style={{ display: 'flex',  justifyContent: 'space-between' }}>
          <Button variant="outlined" onClick={searchAllList} style={{ padding: '3px', margin: '5px' }}>전체 내역</Button>
          {!graphBoard? 
          <Button variant="outlined" onClick={()=>{searchTotalTwoWeeks();setGraphBoard(!graphBoard);searchTotalToday()}} style={{ padding: '3px', margin: '5px' }}>통계 보기</Button>
          :
          <Button variant="outlined" onClick={()=>{setGraphBoard(!graphBoard)}} style={{ padding: '3px', margin: '5px' }}>메뉴 보기</Button>
          }
        </div>
        
        <div style={{ margin: '10px' }}>👤 
            <Input
              type="text"
              placeholder="이름"
              style={{ marginLeft: '10px', fontSize: '16px' }}
              value={userName}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
            />
            <Button variant="outlined" onClick={searchValueButton} style={{ marginLeft: '10px' }}>검색</Button>
        </div>
        <div style={{ margin: '10px'}}>💵 
            <Input
              placeholder="금액"
              style={{ marginLeft: '10px', fontSize: '16px' }}
              value={payPoint}
              onChange={handlePriceInputChange}
            />
            <Button variant="outlined" onClick={plusPoint} style={{ marginLeft: '10px' }}>적립</Button>
            <Button variant="outlined" onClick={minusPoint}style={{ marginLeft: '10px' }}>차감</Button>
            
        </div>
        {selectedItems.length ? 
          <div style={{ margin: '5px 2.5px', padding: '10px', border: '2px solid #E3E1DF', borderRadius: '5px', width: '60%', }}>
              <div style={{ display: 'flex', justifyContent: 'space-around', height: '30px', paddingBottom: '20px' }}>
                <div style={{ fontSize: '20px' }}>주문 메뉴</div>
                <Button variant="outlined" style={{ padding: '10px' }} onClick={() => { oderMenuReset(); } }>초기화</Button>
              </div>
              {selectedItems.reduce((accumulator, item) => {
                const existingItem = accumulator.find((accItem) => accItem.name === item.name);
                if (existingItem) {
                  existingItem.count += 1;
                } else {
                  accumulator.push({ ...item, count: 1 });
                }
                return accumulator;
              }, []).map((item, index) => (
                <div key={index}>
                  <div style={{ fontSize: '12px', marginTop: '3px' }}>{item.name}{item.count > 1 ? `x${item.count}` : ''}</div> <div style={{ textAlign: 'end', fontSize: '10px' }}>{item.price * item.count}원</div>
                </div>
              ))}
            </div>
        :
        <></>
        }
        {/* 주문메뉴 칸 */}
       
        {remainPayPoint ? 
        <div style={{ margin: '20px', fontSize: '30px' }}>잔여 금액은 "{remainPayPoint}" 원 입니다.</div> : null } 
        <hr />
        <div style={{display:'flex', justifyContent: 'space-between'}}>
          <h3>적립 내역</h3>
          {/* <div style={{display:'flex'}}>
            <Button variant="outlined" style={{ padding: '5px', margin: '10px' }}>이전</Button>
            <Button variant="outlined" style={{ padding: '5px', margin: '10px' }}>다음</Button>
          </div> */}
        </div>
        
        <TableContainer style={{ maxHeight: '65vh', overflow: 'scroll' }}>
        <Table  aria-label="simple table">
        {remainPayPointList.length > 0 ? (
          <>
            <TableHead style={{ position:'sticky', top: 0, backgroundColor: '#F5F5F4'}}>
              <TableRow>
                {remainPayPointList[0].userName ? 
                <TableCell 
                  align="center"
                >이름</TableCell>: null}
                <TableCell 
                  align="center"
                >유형</TableCell>
                <TableCell 
                  align="center"
                >금액</TableCell>
              <TableCell 
                  align="center"
                >누적 잔여 금액</TableCell>
                <TableCell 
                  align="center"
                >날짜</TableCell>
                
              </TableRow>
            </TableHead>
            <TableBody>
                    {remainPayPointList.map((item, index) => {
                      const newDate = new Date(item.createdDate).toLocaleString('ko-KR');
                      return(
                        <TableRow key={index}>
                          {item.userName ? 
                        <TableCell 
                        align="center"
                      >
                        {item.userName}
                    </TableCell>
                        :
                        null
                        }
                        <TableCell 
                          sx={{ color: item.status === "적립" ? "blue" : item.status === "사용" ? "red" : ""}}
                          align="center"
                        >
                          {item.status}
                        </TableCell>
                        <TableCell
                          sx={{ color: item.status === "적립" ? "blue" : item.status === "사용" ? "red" : ""}}
                          align="center"
                        >
                          {item.status === "적립" ? "➕ ": "➖ "}
                          {item.payPoint}
                        </TableCell>
                        <TableCell
                          align="center"
                        >
                          {item.totalPoints}
                        </TableCell>
                        < TableCell  
                        align="center"
                        >	
                          {newDate}
                        </TableCell>	
                    </TableRow>	
                    ) })}
              </TableBody>
          </>
        ) : (
          <>
              적립 내역이 없습니다.
          </>
        )}
        </Table>
        </TableContainer>
        
        </div>
        
        {!graphBoard ? 

        <>
        <div style={{ margin: '5px 5px 5px 2.5px', justifyContent: 'center', padding: '10px', border: '2px solid #E3E1DF', borderRadius: '5px', backgroundColor: '#F5F5F4' }}>
            <div style={{display: 'flex'}}>
              <div>
                {menu.map((item, index) => {
                  return (
                    <Button variant="outlined"
                      key={index}
                      style={{
                        margin: '3px',
                        borderRadius: '5px',
                        width: '180px',
                        height: '50px'
                      }}
                      onClick={() => handleItemClick(item)}
                    >
                      <div>
                        <div>{item.name}</div>
                        <div>{item.price}</div>
                      </div>
                    </Button>
                  );
                })}
              </div>

              <div>
                {drink.map((item, index) => {
                  return (
                    <Button variant="outlined"
                      key={index}
                      style={{
                        margin: '3px',
                        borderRadius: '5px',
                        width: '200px',
                        height: '50px'
                      }}
                      onClick={() => handleItemClick(item)}
                    >
                      <div>
                        <div>{item.name}</div>
                        <div>{item.price}</div>
                      </div>
                    </Button>
                  );
                })}
              </div>
            </div>
            
          </div>
          </>
        : 
          <div
            style={{ width: '100vw',margin: '5px 5px 5px 2.5px', justifyContent: 'center', padding: '10px', border: '2px solid #E3E1DF', borderRadius: '5px', backgroundColor: '#F5F5F4' }}>
            <div>
              <Line style={{ width:'80%'}} data={data} />
            </div>
            <div style={{ padding:'10px', marginTop: '10px'}}>
              <h3>오늘 총 적립 : {todayTotalPoints}원</h3>
              <h3>오늘 총 차감 : {todayTotalUsagePoints}원</h3>
              <h3>전체 잔여 적립금 : {totalRemainingPoints}원</h3>
            </div>
          </div>
        }
      </div>
 );
}

export default App;
